import React, { useMemo, useState, useEffect } from "react";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooter,
  IconButtonDatatable,
  ModalDeleteConfirm,
  SearchInput,
  TableHeader,
  TableToolbar,
} from "App/Component/ui";

import {
  getAllJenisRawat,
  ModalForm,
  headCells,
  deleteJenisRawatById,
} from "./helpers";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";
import { useSearchDatatables } from "App/hooks";
import { PencilIcon } from "App/Assets";
import { defaultDateDisplay } from "App/utils/helpers";

let PageSize = 10;

export default function JenisRawat() {
  const classes = STYLE_DEFAULT_MASTER();
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PageSize);

  const [showModal, setShowModal] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    code: "",
  });

  const [run, setRun] = useState(false);
  const { data, length } = useSearchDatatables(rows, q, ["name", "code"]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    (async () => {
      const res = await getAllJenisRawat();
      if (res) {
        setRows(res);
      }
    })();
  }, [run]);

  useMemo(() => {
    const firstPageIndex = (page - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return data.slice(firstPageIndex, lastPageIndex);
  }, [page, data]);

  return (
    <div className={classes.root}>
      {showModal && (
        <ModalForm
          run={() => setRun(!run)}
          setShowModal={() => setShowModal(false)}
          data={formData}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() =>
            deleteJenisRawatById(
              formData.id,
              () => setRun(!run),
              setShowModalDeleteConfirm,
              setFormData
            )
          }
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <Paper className={classes.paper}>
        <TableToolbar title={"Daftar Jenis Rawat"}>
          <SearchInput withIcon={true} onchange={(e) => setQ(e.target.value)} />
          {/* <MasterButton
            type={"submit"}
            color='green'
            name='Tambah'
            size='md'
            onClick={() => {
              setFormData({
                name: "",
                id: "",
                code: "",
              });
              setShowModal(!showModal);
            }}
          /> */}
        </TableToolbar>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby='tableTitle'
            size={"medium"}
            aria-label='enhanced table'>
            <TableHeader
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={length}
              headCells={headCells}
            />
            <TableBody>
              {stableSort(data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow
                      hover
                      tabIndex={-1}
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "transparent" : "#fff",
                      }}>
                      <TableCell
                        component='th'
                        scope='row'
                        padding='none'
                        align='center'>
                        {index + 1}
                      </TableCell>

                      <TableCell align='left'>
                        <IconButtonDatatable
                          onClick={() => {
                            setFormData({
                              id: row?.id,
                              name: row?.name,
                              code: row?.code,
                            });

                            setShowModal(true);
                          }}>
                          <PencilIcon />
                        </IconButtonDatatable>

                        {/* <IconButtonDatatable
                            onClick={() => {
                              setFormData({
                                ...formData,
                                id: row?.id,
                              });
                              setShowModalDeleteConfirm(
                                !showModalDeleteConfirm
                              );
                            }}>
                            <TrashIcon />
                          </IconButtonDatatable> */}
                      </TableCell>

                      <TableCell align='left'>{row?.code}</TableCell>

                      <TableCell align='left'>{row?.name}</TableCell>
                      <TableCell align='left'>
                        {defaultDateDisplay(row?.createdAt)}
                      </TableCell>
                      <TableCell align='left'>{row?.createdBy}</TableCell>
                      <TableCell align='left'>
                        {defaultDateDisplay(row?.updatedAt)}
                      </TableCell>
                      <TableCell align='left'>{row?.updatedBy}</TableCell>
                    </TableRow>
                  );
                })}
              {rows.length === 0 && (
                <TableRow>
                  <TableCell align='center' colSpan={headCells.length}>
                    Tidak ada data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <DatatablesFooter
          page={page}
          length={length}
          rowsPerPage={rowsPerPage}
          selectRows={[10, 20]}
          onPageChange={(page) => setPage(page - 1)}
          onSelectChange={(e) => setRowsPerPage(e.target.value)}
        />
      </Paper>
    </div>
  );
}
